import request from '@/axios'
export function dynamicFieldApi (payload) {
  return request({
    url: 'certificate/dynamic_field_list',
    method: 'POST',
    data: payload
  })
}

export function saveCerificateApi (payload, customer_id) {
  return request({
    url: `certificate/template/create/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function fetchtemplateCertificateApi (page, customer_id, payload, query) {
  return request({
    url: `certificate/template/list/${customer_id}?attribute=${query.attribute}&direction=${query.direction}&field_type=${query.field_type}&page=${page}`,
    method: 'POST',
    data: payload
  })
}

export function fetchgeneratedCertificateApi (page, customer_id, payload, query) {
  return request({
    url: `certificate/list/${customer_id}?attribute=${query.attribute}&direction=${query.direction}&field_type=${query.field_type}&page=${page}`,
    method: 'POST',
    data: payload
  })
}

export function shareCertificate (payload, customer_id) {
  return request({
    url: `certificate/share/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function updateTemplateCerificateApi (payload, customer_id, template_id) {
  return request({
    url: `certificate/template/edit/${customer_id}/${template_id}`,
    method: 'POST',
    data: payload
  })
}

export function deleteTemplateCerificateApi (payload, customer_id) {
  return request({
    url: `certificate/template/delete/${customer_id}`,
    method: 'POST',
    data: payload
  })
}
export function deleteCerificateApi (payload, customer_id) {
  return request({
    url: `certificate/delete/${customer_id}`,
    method: 'POST',
    data: payload
  })
}
export function fetchbackgroundimgApi (customer_id) {
  return request({
    url: `certificate/file/list/${customer_id}`,
    method: 'GET'
  })
}

export function fetchRepoIdByCustomer (customer_id) {
  return request({
    url: `/certificate/file/getRepositoryId/${customer_id}`,
    method: 'GET'
  })
}

export function saveUploadFileApi (payload) {
  return request({
    url: 'certificate/file/save',
    method: 'POST',
    data: payload
  })
}

export function saveGenerateApi (payload, customer_id) {
  return request({
    url: `certificate/create/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function fetchcourseTem (customer_id) {
  return request({
    url: `certificate/course_specific/template/list/${customer_id}`,
    method: 'GET'
  })
}

export function deleteImg (customer_id, file_id) {
  return request({
    url: `certificate/file/delete/${customer_id}/${file_id}`,
    method: 'GET'
  })
}

export function fetchSharedCertificate (page, staff_id, payload) {
  return request({
    url: `certificate/staff/list/${staff_id}?page=${page}`,
    method: 'POST',
    data: payload
  })
}

export function deleteShareCerificateApi (payload, staff_id) {
  return request({
    url: `certificate/staff/delete/${staff_id}`,
    method: 'POST',
    data: payload
  })
}
export function pdfDownload (payload) {
  return request({
    url: 'certificate/file/download/pdf',
    method: 'POST',
    data: payload
  })
}

export function imageDownload (payload) {
  return request({
    url: 'certificate/file/download/image',
    method: 'POST',
    data: payload
  })
}